(function adwordsTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  const configurations = {
    impressionPrefix: 'adWordsImpressionCustom',
  };

  const culture = document.documentElement.lang || 'en';
  const isCna = culture === 'es';
  const previousModule = global.NewHomeSource.Analytics.AdWordsTracker;
  const isFromEuropeanCountry = !!document.querySelector('[data-is-europan-country]');
  const trackConversionSrc = '//www.googleadservices.com/pagead/conversion_async.js';

  if (isCna || isFromEuropeanCountry) {
    global.NewHomeSource.Analytics.AdWordsTracker = () => { };
    return global.NewHomeSource.Analytics.AdWordsTracker;
  }

  /**
   * @private
   * getData: gets the data from the DOM Node that will be send to AdWords.
   *
   * @param {DOMStringMap} dataset properties of the object.
   * @param {*} prefix to evaluate the properties we want to retrieve.
   * @param {*} attribute being evaluated.
   */
  function getAttributes(dataset, prefix, attribute) {
    const sharedPrefix = configurations.sharedPrefix;
    if (!attribute.startsWith(prefix) && !attribute.startsWith(sharedPrefix)) {
      return;
    }

    const name = attribute.replace(prefix, '').replace(sharedPrefix, '').toLowerCase();

    if (!name) {
      return;
    }

    this[name] = dataset[attribute];
  }

  function loadTrackConversion() {
    const isTrackConversionLoaded = document.querySelector(`[src="${trackConversionSrc}"]`);

    if (isTrackConversionLoaded) {
      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = trackConversionSrc;
    scriptTag.async = 'true';
    scriptTag.type = 'text/javascript';
    document.documentElement.appendChild(scriptTag);
  }

  function AdWordsTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  /**
   * @public
   * impressionTracker: send data related to display events.
   *
   */
  AdWordsTracker.impressionTracker = function impressionTracker() {
    if (!global.google_trackConversion) {
      loadTrackConversion();
      return false;
    }

    if (!this || !this.length) {
      return true;
    }

    this.forEach((element) => {
      const data = element.dataset;
      const ids = data.adWordsImpressionGoogle_conversion_id.split(',');
      const labels = data.adWordsImpressionGoogle_conversion_label.split(',');
      const impressionCustomAtributes = {};
      Object.keys(data).forEach(getAttributes.bind(impressionCustomAtributes, data, configurations.impressionPrefix));
      const length = ids.length;
      for (let i = 0; i < length; i += 1) {
        const id = ids[i] || '';
        const label = labels[i] || undefined;
        const trackEvent = {
          google_conversion_id: id,
          google_conversion_label: label,
          google_custom_params: impressionCustomAtributes,
          google_remarketing_only: true
        };
        global.google_trackConversion(trackEvent);
      }
    });

    return true;
  };

  /**
   * @public
   * impressionTrackerSelector: returns the expression that can be used to query the DOM.
   */
  AdWordsTracker.impressionTrackerSelector = function impressionTrackerSelector() {
    return 'data-ad-words-impression';
  };

  /**
       * @public
       * noConflict: Returns control of NewHomeSource.Analytics.AdWordsTracker to the previous script.
       */
  AdWordsTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.AdWordsTracker = previousModule;
    return AdWordsTracker;
  };

  global.NewHomeSource.Analytics.AdWordsTracker = AdWordsTracker;

  return AdWordsTracker;
}(window));
